import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import useMixPanel from 'hooks/useMixPanel';
import {useCompare} from 'utils/hooks';
import {useComputedReservationDetails} from 'context/computedReservationDetails';
import {
  setExperiencesModalAlreadyShowed,
  getExperiencesModalAlreadyShowed,
} from 'utils/guests';
import {GUEST_APP_EVENTS_NAME, SHOW_EXPERIENCES_MODAL_TIMEOUT_MS} from 'utils/constants';
import {getMembers, getNumberOfGuests} from '../../utils/reservation';
import finishImage from 'assets/bg-summary.png';
import CheckinNavigation from 'components/acommon/CheckinNavigation';
import Page from 'components/acommon/Page';
import StyledIcon from 'components/acommon/StyledIcon';
import BookingStatus from 'components/acommon/BookingStatus';
import Modal from 'components/Modal';
import ShareModal from '../ShareModal';
import styles from './FinishScreen.module.sass';
import {ExperiencesModal} from './';
import {GuestsStatus, ShareBlock} from './styled';

function FinishScreen() {
  const {t} = useTranslation();
  const {areGuestFieldsDisabled, reservation, hasUpselling} =
    useComputedReservationDetails();
  const {IdGuestAppEvents} = useMixPanel();
  const [isShareModalOpen, setShareModalOpen] = React.useState(false);
  const [isExperiencesModalOpen, setExperiencesModalOpen] = React.useState(false);
  const numberOfRegistredGuests = getMembers(reservation).length;
  const numberOfGuests = getNumberOfGuests(reservation);
  const pendingGuests = numberOfGuests - numberOfRegistredGuests;

  const hasItemIdChanged = useCompare(reservation?.id);

  React.useEffect(() => {
    if (hasItemIdChanged && !getExperiencesModalAlreadyShowed()) {
      setTimeout(() => {
        setExperiencesModalOpen(true);
        IdGuestAppEvents(GUEST_APP_EVENTS_NAME.experiencieShowModal);
        setExperiencesModalAlreadyShowed(true);
      }, SHOW_EXPERIENCES_MODAL_TIMEOUT_MS);
    }
  }, [hasItemIdChanged, IdGuestAppEvents]);

  const closeExperiencesModal = () => {
    IdGuestAppEvents(GUEST_APP_EVENTS_NAME.experiencieIgnoredModal);
    setExperiencesModalOpen(false);
  };

  return (
    <Page showFooterOnlyMobile>
      <Modal
        open={isShareModalOpen}
        onClose={() => setShareModalOpen(false)}
        closeOnDocumentClick
        closeOnEscape
        withCloseButton
      >
        <ShareModal />
      </Modal>
      <Modal
        open={isExperiencesModalOpen && hasUpselling}
        onClose={() => closeExperiencesModal()}
        closeOnDocumentClick
        closeOnEscape
        withCloseButton
      >
        <ExperiencesModal onCloseModal={closeExperiencesModal} />
      </Modal>
      <CheckinNavigation title={t('congratulations')} />
      <div className={styles.wrapper}>
        <img className={styles.finishImage} src={finishImage} alt="You've registered!" />
        <div className={styles.finishDetails}>
          {!areGuestFieldsDisabled && (
            <BookingStatus className={styles.finishTable} isOnFinishPage />
          )}
          <ShareBlock>
            <div className="text">
              {t('dont_have_your_guests_question')}
              <br />
              {t('share_this_link_to_guests')}
              <br />
            </div>
            <div className="links">
              <div className="link" onClick={() => setShareModalOpen(!isShareModalOpen)}>
                <StyledIcon name="shareLink" color="#2148FF" />
                <span>{t('share_checkin_link')}</span>
              </div>
              <GuestsStatus>
                <StyledIcon name="shareGuests" color="#2148FF" />
                {/* <span>{(4 === 4) ? 'All Guests Registered' : }</span> */}

                {!areGuestFieldsDisabled ? (
                  <span>
                    {numberOfGuests === numberOfRegistredGuests
                      ? t('all_guests_registered')
                      : t('count_guests_registered', {count: pendingGuests})}
                  </span>
                ) : (
                  <span>{t('all_guests_registered')}</span>
                )}
              </GuestsStatus>
              <div className="link">
                <StyledIcon name="shareFinishLater" color="#2148FF" />
                <Link to="/" className="link-home">
                  {t('return_to_home')}
                </Link>
              </div>
            </div>
          </ShareBlock>
        </div>
      </div>
    </Page>
  );
}

export {FinishScreen};
